import $ from 'jquery';
import throttle from 'lodash/throttle.js';

export default class Footer {
  constructor(Ui) {
    this.Ui = Ui;
    initToTopButton.call(this);
  }
}

/**
 * Copy from ui/ui.js
 */
function initToTopButton() {
  const $button = $('#btn-to-top');
  let lastPixelScrolled = 0;

  this.Ui.$window.on('scroll.Ui.toTopButton', throttle(
      () => {
        const pixelScrolled = this.Ui.$window.scrollTop();
        if (pixelScrolled <= lastPixelScrolled) {
          $button.show();
        } else {
          $button.hide();
        }
        lastPixelScrolled = pixelScrolled;
      },
      125,
  ));

  $button.on('click', function() {
    $('html, body').animate({
      scrollTop: 0,
    }, 1000);
    return false;
  });
}
